module.exports = __webpack_public_path__ + "static/media/sound-alarm.aaea53e6.mp3";